const ExplanationTable = ({ children, title = 'Nome da coluna', description = 'Descrição' }: { children: JSX.Element[]; title?: string; description?: string }) => (
  <table className='w-full table-fixed border-separate border-spacing-0 rounded-md border border-gray'>
    <thead className='border-0 border-gray text-center text-gray-black text-sm leading-135'>
      <tr className='font-medium'>
        <th className='border-0 border-gray'>
          <div className='rounded-ss-md bg-gray-lightest p-2.5'>{title}</div>
        </th>
        <th className='border-gray border-s'>
          <div className='rounded-se-md bg-gray-lightest p-2.5'>{description}</div>
        </th>
      </tr>
    </thead>
    <tbody className='font-normal text-gray-dark text-sm leading-135'>{children}</tbody>
  </table>
);

export default ExplanationTable;
